import React, { useState } from 'react';
import { NomineeModal } from './Nominee';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';

type Props = {
  className: string;
  title: string;
  description: string;
  avatar: string;
  link: string | undefined;
};

const NomineeWidget: React.FC<Props> = ({ className, title, description, avatar, link }) => {
  const [modalShow, setModalShow] = useState(false);

  return (
    <div>
      <a className={`hoverable`} onClick={() => setModalShow(true)}>
        <div
          className={`card shadow-sm bgi-no-repeat ${className}`}
          style={{
            backgroundPosition: 'right',
            backgroundSize: '18% auto',
            backgroundColor: '#fff',
            backgroundImage: `url(${toAbsoluteUrl('/media/futuriskicon/' + avatar)})`,
          }}
        >
          {/* begin::Body */}
          <div className='card-body'>
            <div className='card-title fw-bolder text-black text-hover-primary fs-4'>
              {title}
            </div>
            <p
              className='text-muted fw-bold fs-7 m-0'
              dangerouslySetInnerHTML={{ __html: description }}
            >
              {/* existing code */}
            </p>
          </div>
          {/* end::Body */}
        </div>
      </a>
      <NomineeModal show={modalShow} handleClose={() => setModalShow(false)} />
    </div>
  );
};

export { NomineeWidget };
